import React from 'react';
import { Download } from 'react-bootstrap-icons';
import { Form } from 'react-bootstrap';

import CareMapprButton from '../../../../../components/Button/CareMapprButton';
import ExportSettingsForm from './ExportSettingsForm';
import type { UseFormReturn } from 'react-hook-form';
import type { MedProfileForm } from '../../../types';
import { useMedicationProfileDirty } from '../../../context/MedicationProfileDirtyProvider';
import CaremapprConfirmation from '../../../../../components/Confirmation/CaremapprConfirmation';

interface ExportSettingsProps {
  form: UseFormReturn<MedProfileForm, any, MedProfileForm>;
  canEdit: boolean;
  onPreview: () => void;
  onDownload: () => void;
  isPreviewLoading?: boolean;
  isDownloadLoading?: boolean;
  createMedProfile?: boolean;
}
const ExportSettings = ({
  createMedProfile,
  form,
  canEdit,
  onPreview,
  onDownload,
  isPreviewLoading,
  isDownloadLoading,
}: ExportSettingsProps) => {
  const { isDirty } = useMedicationProfileDirty();
  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const [pendingAction, setPendingAction] = React.useState<
    'preview' | 'download' | null
  >(null);

  const guardUnsaved = (action: 'preview' | 'download') => {
    if (isDirty) {
      setPendingAction(action);
      setConfirmOpen(true);
      return;
    }
    action === 'preview' ? onPreview() : onDownload();
  };

  return (
    <Form className="export-settings-container">
      <ExportSettingsForm form={form} canEdit={canEdit} />
      {!createMedProfile && (
        <div className="d-flex gap-2">
          <CareMapprButton
            extraClassNames="action-button"
            label="Preview"
            isLoading={isPreviewLoading}
            variant="secondary"
            type="button"
            onClick={() => guardUnsaved('preview')}
          />
          <CareMapprButton
            extraClassNames="action-button"
            label="Download"
            isLoading={isDownloadLoading}
            endIcon={<Download size={16} />}
            type="button"
            onClick={() => guardUnsaved('download')}
          />
        </div>
      )}
      <CaremapprConfirmation
        open={confirmOpen}
        text={
          'You have unsaved changes. Do you want to continue without saving?'
        }
        icon="warning"
        showCancelButton={true}
        confirmButtonText="Continue"
        cancelButtonText="Cancel"
        onConfirm={() => {
          if (pendingAction === 'preview') onPreview();
          if (pendingAction === 'download') onDownload();
        }}
        onCancel={() => {
          // do nothing
        }}
        onClose={() => {
          setConfirmOpen(false);
          setPendingAction(null);
        }}
      />
    </Form>
  );
};

export default ExportSettings;
